import React from 'react';
import { HeaderIconProps } from '../Header/icons/types';

export type Option = {
  text: string;
  onChoose: () => void;
  className?: string;
  Icon?: React.FC<HeaderIconProps>;
  disabled?: boolean;
  isRed?: boolean;
};

export const PopupOption: React.FC<Option> = ({
  text,
  onChoose,
  className = '',
  Icon,
  disabled = false,
  isRed = false,
}: Option): JSX.Element => {
  return (
    <div
      className={`popup-option ${className} ${
        disabled ? 'popup__option-disabled' : ''
      } ${isRed && !disabled ? 'options__red' : ''}`}
      onClick={onChoose}
    >
      {Icon ? (
        <div className="popup__option-icon">
          <Icon disabled={disabled} />
        </div>
      ) : null}
      <span>{text}</span>
    </div>
  );
};
